<template>
  <form @submit="onSubmit">
    <label for="login">Логин</label>
    <input type="text" name="login" v-model="form.login" />
    <label for="password">Пароль</label>
    <input type="password" name="password" v-model="form.password" />
    <button type="submit">Войти</button>
  </form>
</template>


<script>
import ApiService from "../services/api-service";

export default {
  name: "RggLogin",
  data() {
    return {
      form: {
        login: "",
        password: ""
      },
      error: false
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      ApiService.put("auth/login", this.form).then(response => {
        localStorage.setItem("token", response.data.token)
        this.$router.push({ name: 'Home' })
      }).catch(() => {
        this.error = true
      })
    }
  }
}
</script>

<style scoped>
.card{
  border-radius: 5px;
}
</style>
